<template>
    <div ref="container">
        <div class="banner-wrap">
            <div class="banner">
                <div class="swipe-wrap">
                    <van-swipe :autoplay="3000" indicator-color="white" width="100%" ref="banner">
                        <van-swipe-item v-for="(banner, b) in banners" :key="b">
                            <van-image
                                width="100%"
                                height="100%"
                                fit="cover"
                                :src="banner.url"
                                :alt="banner.name"
                            />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
        <div class="content-wrap ">
            <van-tabs v-model="active" title-active-color="#333">
                <van-tab v-for="(cate, c) in cates" :title="cate.name" :key="c"></van-tab>
            </van-tabs>
            <div class="lists">
                <router-link
                    :to="'/news/detail/' + item.id"
                    class="item"
                    v-for="(item, i) in lists"
                    :key="i"
                >
                    <div class="image">
                        <van-image :src="item.thumb" fit="cover" />
                    </div>
                    <div class="name">{{ item.title }}</div>
                    <div class="desc">
                        {{ item.description }}
                    </div>
                </router-link>
                <van-loading v-if="!loaded">
                    加载中...
                </van-loading>
                <van-empty
                    description="暂无任何内容"
                    :image="require('@images/nodata.png')"
                    v-if="lists.length === 0"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { getClassRoomData } from '@api/public';
import { getArticleList } from '@api/public';
export default {
    name: 'Classroom',
    data() {
        return {
            banners: [],
            cates: [],
            curCate: {},
            lists: [],
            active: 0,
            where: {
                page: 1,
                limit: 12
            },
            cid: 0,
            loaded: false,
            loading: false
        };
    },
    created() {
        this.getClassRoom();
    },
    watch: {
        $route(n) {
            if (n.name === 'Classroom') {
                this.getClassRoom();
                if (this.cates.length > 0) {
                    this.$set(this, 'cid', this.cates[this.active].id);
                    this.where.page = 1;
                    this.loaded = false;
                    this.loading = false;
                    this.$set(this, 'lists', []);
                    this.getArticleLists();
                }
            }
        },
        active: function() {
            this.$set(this, 'cid', this.cates[this.active].id);
            this.where.page = 1;
            this.loaded = false;
            this.loading = false;
            this.$set(this, 'lists', []);
            this.getArticleLists();
        }
    },
    mounted() {
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getArticleLists();
        });
    },
    methods: {
        getClassRoom() {
            let that = this;
            getClassRoomData().then(res => {
                that.$set(that, 'banners', res.data.banners);
                that.$set(that, 'cates', res.data.cates);
                if (res.data.cates.length > 0) {
                    that.$set(that, 'cid', res.data.cates[0].id);
                    that.getArticleLists();
                }
            });
        },
        getArticleLists() {
            let that = this;
            if (this.loaded == true || this.loading == true) return;
            this.loading = true;
            getArticleList(this.where, this.cid).then(res => {
                that.loading = false;
                that.lists.push.apply(that.lists, res.data);
                that.loaded = res.data.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
            });
        }
    }
};
</script>
